import Breadcrumb from "Components/Common/Breadcrumb";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";

// Components …
import CardUser from "./card-user";
import CardWelcome from "./card-welcome";
import MiniWidget from "./mini-widgets";
import WalletBalance from "./Wallet-balance";
import Overview from "./overview";
import Transactions from "./transaction";
import Notifications from "./notification";
import BuySell from "./buy-sell";
import AccountsOverview from "Components/Common/GraficHistoricalBalance";
import {
  createBusinessBridge,
  createCustomerIndividual,
  getEntityTypeLog,
} from "../../helpers/dataBackend";
import { decryptState } from "shared/encryptInfo";
import { setAuthorization } from "../../helpers/api_helper";

/* ---------- control de pasos ---------- */
type ModalStage =
  | null
  | "accepted"
  | "confirm"
  | "creating"
  | "waiting"
  | "created"
  | "tosKyc";

function MyAccounts() {
  document.title = "Ditobanx";

  const [existingProcess, setExistingProcess] = useState(true);
  const [stage, setStage] = useState<ModalStage>(null);
  const [userId, setUserId] = useState<number>(0);
  const [hasVirtualAccount, setHasVirtualAccount] = useState<boolean>(false);
  const [entityType, setEntityType] = useState<any>();
  const [agreementAccepted, setAgreementAccepted] = useState(false);
  const [signedAgreementId, setSignedAgreementId] = useState<string | null>(
    null
  );

  /* al montar */
  useEffect(() => {
    const token = localStorage.getItem("authUser");
    setAuthorization(token);
    if (existingProcess) setStage("confirm");
  }, [existingProcess]);

  const [signedAgreementUrl, setSignedAgreementUrl] = useState<string | null>(
    null
  );

  const getData = async () => {
    const nose = localStorage.getItem("userInfo");
    const id_user = decryptState(nose || "{}");
    setUserId(id_user.id);

    try {
      if (!hasVirtualAccount) {
        const response = await getEntityTypeLog(id_user.id);
        const parsedResponse = JSON.parse(response.data);
        setEntityType(parsedResponse?.entityType);
        setSignedAgreementUrl(
          parsedResponse?.signed_agreement_url?.url || null
        );
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const signedId = urlParams.get("signed_agreement_id");

    if (!signedId) {
      // TODO QUITAR '!'
      setAgreementAccepted(true);
      setSignedAgreementId(signedId);
      setStage("accepted"); // nuevo modal de aceptación
      // Elimina el parámetro de la URL (opcional)
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  useEffect(() => {
    // bloquea/desbloquea scroll global
    document.body.style.overflow = stage ? "hidden" : "";
  }, [stage]);

  /* secuencia automática */
  const handleContinue = async () => {
    try {
      console.log(signedAgreementId);
      setStage("creating");
      if (entityType.code === "IND") {
        const response = await createCustomerIndividual({ data: userId });
        console.log(response);
      } else {
        console.log("=========BUSINESS=============");
        const response = await createBusinessBridge({ data: userId });
        const parsedData = JSON.parse(response.data);
        console.log(parsedData);
      }

      setTimeout(() => setStage("waiting"), 1500);
      setTimeout(() => setStage("created"), 3000);
      setTimeout(() => setStage("tosKyc"), 4500);
    } catch (error) {}
  };

  const closeAll = () => {
    setStage(null);
    setExistingProcess(false);
  };

  /* contenido del modal según etapa */
  const renderContent = () => {
    switch (stage) {
      case "confirm":
        return (
          <>
            <h2 style={styles.modalTitle}>¿Crear una cuenta con Bridge?</h2>
            <div style={styles.buttonGroup}>
              <button
                style={styles.confirmButton}
                onClick={() => {
                  if (signedAgreementUrl) {
                    window.location.href = signedAgreementUrl;
                  }
                }}
              >
                Continuar
              </button>
            </div>
          </>
        );
      case "creating":
        return <h2 style={styles.modalTitle}>Creando…</h2>;
      case "waiting":
        return <h2 style={styles.modalTitle}>Espera un momento…</h2>;
      case "created":
        return <h2 style={styles.modalTitle}>¡Tu cuenta ha sido creada!</h2>;
      case "tosKyc":
        return (
          <>
            <h2 style={styles.modalTitle}>
              Realiza el ToS y KYC para crear tu cuenta virtual
            </h2>

            {/* NUEVO TEXTO + ENLACES */}
            <p style={{ margin: "12px 0", color: "#555" }}>
              Para finalizar, revisa y acepta nuestros&nbsp;
              <a
                href="https://bridge.example.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.link}
              >
                Términos de Servicio
              </a>
              &nbsp;y completa tu&nbsp;
              <a
                href="https://bridge.example.com/kyc"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.link}
              >
                verificación KYC/B
              </a>
              .
            </p>

            <div style={styles.buttonGroup}>
              <button style={styles.confirmButton} onClick={closeAll}>
                Entendido
              </button>
            </div>
          </>
        );
      case "accepted":
        return (
          <>
            <h2 style={styles.modalTitle}>
              Ya has aceptado los términos y condiciones.
            </h2>
            <div style={styles.buttonGroup}>
              <button
                style={styles.confirmButton}
                onClick={() => {
                  handleContinue();
                }}
              >
                Continuar
              </button>
            </div>
          </>
        );

      default:
        return null;
    }
  };

  /* ---------- JSX ---------- */
  return (
    <React.Fragment>
      <div style={{ filter: stage ? "blur(4px)" : "none", transition: "0.3s" }}>
        <div className="page-content">
          <Container fluid>
            <Breadcrumb title="My Accounts" breadcrumbItem="My Accounts" />

            <AccountsOverview />
            <Row>
              <CardUser />
              <Col xl={8}>
                <CardWelcome />
                <Row>
                  <MiniWidget />
                </Row>
              </Col>
            </Row>

            <Row>
              <WalletBalance dataColors='["--bs-primary", "--bs-warning", "--bs-info"]' />
              <Overview dataColors='["--bs-warning"]' />
            </Row>

            <Row>
              <Transactions />
              <Notifications />
              <BuySell />
            </Row>
          </Container>
        </div>
      </div>

      {/* ---------- Modal (solo si hay etapa) ---------- */}
      {stage && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>{renderContent()}</div>
        </div>
      )}
    </React.Fragment>
  );
}

/* ---------- ESTILOS ---------- */
const styles: { [key: string]: React.CSSProperties } = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalBox: {
    backgroundColor: "#fff",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    maxWidth: "400px",
    width: "90%",
    textAlign: "center",
  },
  modalTitle: {
    marginBottom: "15px",
    color: "#333",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "center",
    marginTop: "30px",
    gap: "10px",
  },
  confirmButton: {
    padding: "10px 20px",
    borderRadius: "8px",
    backgroundColor: "#4caf50",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
  },
};

export default MyAccounts;
